import React from "react";
import ServiceTrackPage from "./ServiceTrackPage";

const aiInfrastructurePhases = [
  {
    step: "01",
    title: "Infrastructure Audit",
    detail:
      "We assess your current AI deployment environment, identify reliability gaps, and establish baseline performance, quality, and cost metrics.",
  },
  {
    step: "02",
    title: "Observability & Eval Setup",
    detail:
      "We instrument your AI systems with output quality scoring, drift detection, latency monitoring, and alerting so nothing degrades silently.",
  },
  {
    step: "03",
    title: "LLMOps Implementation",
    detail:
      "We establish prompt versioning, model management, token optimization, and infrastructure scaling controls for efficient and auditable operations.",
  },
  {
    step: "04",
    title: "Ongoing Operations",
    detail:
      "We operate your AI infrastructure on a managed basis with SLA-backed uptime, incident response, and monthly reporting on performance and outcomes.",
  },
];

const AIInfrastructurePage = () => {
  return (
    <ServiceTrackPage
      trackLabel="AI Infrastructure Track"
      title="The Backbone That Keeps Your AI Production-Ready"
      accentLine="Operate AI with precision and confidence."
      description="Deploying AI is step one. Keeping it accurate, reliable, and improving over time is what most teams aren't equipped to do alone. We operate the AI systems we build — managing infrastructure, monitoring performance, tuning models, controlling costs, and reporting outcomes every month."
      topPrimaryCtaLabel="Book an Infrastructure Session"
      topSecondaryCtaLabel="See Execution Model"
      engagementId="ai-infrastructure-delivery"
      outcomesHeading="What You Walk Away With"
      outcomes={[
        "24/7 monitoring with SLA-backed incident response and API health checks",
        "AI evaluation framework with output quality scoring and drift detection",
        "Prompt versioning, model management, and token cost optimization",
        "Monthly performance reports with full visibility into AI system health",
      ]}
      metricsHeading="Expected Outcomes"
      metrics={[
        { value: "99.9%", label: "infrastructure uptime target" },
        { value: "<2h", label: "incident response time" },
        { value: "100%", label: "audit-ready workflows" },
        { value: "Monthly", label: "performance reporting" },
      ]}
      phases={aiInfrastructurePhases}
      finalEyebrow="Final Step"
      finalTitleLine="Don't let your AI degrade in silence."
      finalAccentLine="We operate it so you don't have to."
      finalDescription="From uptime and evals to cost control and monthly reporting — we manage the operational layer that keeps every AI system performing at the standard your business requires."
      finalCtaLabel="Book a Free Audit"
    />
  );
};

export default AIInfrastructurePage;
